import React, { useEffect, useState } from 'react';
import {
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  DeleteButton,
  useDataProvider,
  useRecordContext,
} from 'react-admin';
import { Box } from '@mui/material';
import PackagesFormFields from '../customForms/PackagesFormFields';

const ConfigsTitle = () => {
  const record = useRecordContext();
  return <span>Embalagem {record ? `${record.name || 'sem nome'}` : ''}</span>;
};

const CustomToolbar = props => (
  <Toolbar
    {...props}
    sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 100,
      backgroundColor: 'background.paper',
      borderTop: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      justifyContent: 'space-between',
      px: 2,
      py: 1.5,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <SaveButton />
    </Box>
    <DeleteButton mutationMode="pessimistic" label="Apagar" />
  </Toolbar>
);

const PackagesEdit = () => {
  const dataProvider = useDataProvider();
  const [allRecyclings, setAllRecyclings] = useState([]);
  const [loading, setLoading] = useState(true);

  const record = useRecordContext();

  useEffect(() => {
    const fetchRecyclings = async () => {
      try {
        const recyclingsRes = await dataProvider.getList('recyclings', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'Name', order: 'ASC' },
          filter: {},
        });

        setAllRecyclings(recyclingsRes.data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch recyclings:', err);
      }
    };

    fetchRecyclings();
  }, [dataProvider]);

  if (loading) return <p>Loading...</p>;

  // Grab materials directly from the record, or fallback to empty array
  const allMaterials = record?.Materials || [];

  return (
    <Edit title={<ConfigsTitle />}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <PackagesFormFields
          allRecyclings={allRecyclings}
          allMaterials={allMaterials}
        />
      </SimpleForm>
    </Edit>
  );
};

export default PackagesEdit;
